<template>
  <div class="footer">
    <div class="footer_main">
      <div class="footer_left">
        <div class="footer_logo">
          <img
            src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933747160/logo_white.png"
            alt=""
          />
        </div>
        <div class="footer_box">
          <div class="item">
            <div>公司地址</div>
            <div>成都市金牛区金科南路169号1栋10层1016号</div>
          </div>
          <div class="item">
            <div>联系电话</div>
            <div>028-61666051</div>
          </div>
        </div>
        <div class="footer_record">
          <span>备案信息</span>
          <a
            style="margin-left: 16px"
            href="https://beian.miit.gov.cn"
            target="_blank"
            >蜀ICP备2025128641号-1</a
          >
        </div>
        <div class="footer_record">
          <span>入网信息</span>
          <span style="padding-left: 16px; display: flex; align-items: center">
            <img
              style="width: 16px"
              src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/31/1743391386598/beian.png"
              alt=""
              srcset=""
            />
            <a href="http://www.beian.gov.cn" target="_blank"
              >川公网安备51010602002812号</a
            >
          </span>
        </div>
      </div>
      <div class="footer_right">
        <div class="jump_box">
          <div class="jump_item" v-for="(item, index) in jumpList" :key="index">
            <div class="item_title">{{ item.title }}</div>
            <div
              class="item_label"
              v-for="(label, idx) in item.children"
              :key="idx"
            >
              <router-link :to="label.path"> {{ label.title }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  getCurrentInstance,
  onMounted,
} from "vue";

export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance() as any;

    const state = reactive({
      jumpList: [
        {
          title: "核心业务",
          children: [
            {
              title: "全过程工程咨询服务",
              path: "/core?type=0",
            },
            {
              title: "全过程造价咨询",
              path: "/core?type=1",
            },
            {
              title: "招标与采购专业咨询",
              path: "/core?type=2",
            },
            {
              title: "工程监理与运维专业咨询",
              path: "/core?type=3",
            },
            {
              title: "全过程BIM项目管理",
              path: "/core?type=4",
            },
          ],
        },
        {
          title: "工程业绩",
          children: [
            {
              title: "造价业绩",
              path: "/project?type=0",
            },
            {
              title: "监理业绩",
              path: "/project?type=1",
            },
            {
              title: "招标代理业绩",
              path: "/project?type=2",
            },
          ],
        },
        {
          title: "新闻资讯",
          children: [
            {
              title: "公司新闻",
              path: "/news?type=1",
            },
            {
              title: "行业资讯",
              path: "/news?type=2",
            },
            {
              title: "招投标消息",
              path: "/news?type=3",
            },
          ],
        },
        {
          title: "企业文化",
          children: [
            {
              title: "企业文化",
              path: "/culture?anchor=page",
            },
            {
              title: "组织架构",
              path: "/culture?anchor=framework",
            },
          ],
        },
      ],
    });
    onMounted(() => {});
    return {
      ...toRefs(state),
    };
  },
});
</script>

<style scoped lang="scss">
.footer {
  background: url("https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933769252/footer_bg.png")
    no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  height: 400px;
  padding: 58px 0px 65px;
  .footer_main {
    width: 1600px;
    margin: 0 auto;
    display: flex;
    .footer_left {
      .footer_logo {
        img {
          display: block;
        }
      }
      .footer_box {
        width: 620px;
        padding: 40px 0px 32px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        display: flex;
        margin-bottom: 32px;
        .item {
          margin-right: 90px;
          div:nth-of-type(1) {
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
          }
          div:nth-of-type(2) {
            padding-top: 16px;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
      .footer_record {
        padding-top: 8px;
        display: flex;
        align-items: center;
        span {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
        }
        a {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
          text-decoration: underline;
        }
      }
    }
    .footer_right {
      padding-left: 132px;
      .jump_box {
        display: flex;

        .jump_item {
          margin-right: 78px;
          .item_title {
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            padding-bottom: 24px;
          }
          .item_label {
            padding-bottom: 16px;
            a {
              text-decoration: none;
              font-size: 14px;
              color: rgba(255, 255, 255, 0.6);
            }
          }
        }
      }
    }
  }
}
</style>